import BaseVue, { VueConstructor } from "vue";
import { Store } from "vuex";

export type Credentials = { pub: string; priv?: string };

export type Admin = {
  name: string;
  email: string;
  password: string;
  superuser: boolean;
  dirty?: boolean;
  fresh?: boolean;
};

export type Election = {
  archived?: boolean;
  ballots?: Array<Ballot>;
  code?: boolean;
  data?: boolean;
  description: string;
  end?: Date;
  name: string;
  published?: boolean;
  questions: Array<Question>;
  resultsPublished?: boolean;
  start?: Date;
  tally?: string;
  tallyEncrypted?: string;
  tallyTime?: Date;
  threshold: number;
  trusteesSealed?: boolean;
  externalTrustees?: Array<Trustee>;
  uuid: Uuid;
  voters: Array<Voter>;
};

export type Uuid = string;

export type Question = {
  answers: Array<string>;
  min: number;
  max: number;
  question: string;
  blank: boolean;
};

export type Voter = {
  code?: string;
  data?: string;
  dirty?: boolean;
  email: Email;
  name: string;
  phone?: string;
  votes: number;
  time?: Date;
};

export type Email = string;

export type Proof = { challenge: string; response: string };

export type Signature = {
  challenge: string;
  public_key: string;
  response: string;
};

export type Ballot = {
  answers: Array<Answer>;
  election_hash: string;
  election_uuid: string;
  signature: Signature;
};

export type Answer = {
  blank_proof: Array<Proof>;
  choices: Array<Choice>;
  individual_proofs: Array<Array<Proof>>;
  overall_proof: Array<Proof>;
};

export type Choice = { alpha: string; beta: string };

export type Trustee = {
  code?: string;
  credentials?: Credentials;
  dirty?: boolean;
  email: string;
  originalEmail?: string;
  partial?: string;
  polynomials?: string;
  threshold: boolean;
  vinput?: string;
  voutput?: string;
};

export type PublicKey = { group: Group; y: string };

export type Group = { g: string; p: string; q: string };

export type State = {
  administrators: Array<Admin> | null;
  elections: Map<string, Election> | null;
  electionsTracker: number;
  email: string | null;
  password: string | null;
  token: string | null;
  version: string | null;
};

abstract class TypedVue extends BaseVue {
  public $store!: Store<State>;
}

export const Vue = BaseVue as VueConstructor<TypedVue>;

export type Column = {
  label: string;
  field: string;
  type?: string;
  sortable?: boolean;
};
